var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"IndexSICPE_div"}},[_c('menusuperior',{attrs:{"titulo":"SICPE","subtitulo":"Sistema de Criterios Penales"}}),_vm._v(" "),_c('menuizquierda'),_vm._v(" "),_c('main',{staticClass:"content-area"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-503404da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SICPE/Comun/Plantilla.vue
// module id = null
// module chunks = 